export function VerityConnectBrand({ className = "", companyLine = true, inverse = false }: {
  className?: string;
  companyLine?: boolean;
  inverse?: boolean;
}) {
  return <span className={`verity-connect-brand ${className}`.trim()}>
    <img src={inverse ? "/brand/verityword-mark-inverse.png" : "/brand/verityword-mark.png"} alt="" aria-hidden="true" />
    <strong>Verity Connect</strong>
    {companyLine && <small>by VerityWord</small>}
  </span>;
}
